import URL from 'url-parse';

// BASE_URL always points to the current origin.
// In dev, the Vite proxy forwards /api requests to the backend (configured via VITE_OVERRIDE_API_URL in vite.config.mjs).
// In production, frontend and backend run on the same domain.
export const BASE_URL = new URL(window.location.href).origin;

export const NODE_ENV = import.meta.env.VITE_NODE_ENV;
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
export const SENTRY_KEY = import.meta.env.VITE_SENTRY_KEY;

// Build release id (package version + git hash), injected at build time via vite.config.mjs `define`.
// Used as Sentry `release` so every event is attributable to a specific deploy.
export const APP_RELEASE = import.meta.env.VITE_APP_RELEASE || 'dev';
